"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _reactTransitionGroup = require("react-transition-group");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: fixed;\n\n\t&.", "-enter-active {\n\t\tbottom: -200px;\n\t\ttransform: translateY(-200px);\n\t\ttransition: transform 200ms;\n\t}\n\n\t&.", "-enter-done {\n\t\tbottom: 0;\n\t}\n\n\t&.", "-exit-active {\n\t\tbottom: 0;\n\t\ttransform: translateY(600px);\n\t\ttransition: transform 800ms;\n\t}\n\n\t&.", "-exit-done {\n\t\tbottom: -200px;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var animationName = 'slideIn';

var SlideUpAnimation = _styledComponents.default.section(_templateObject(), animationName, animationName, animationName, animationName);

SlideUpAnimation.displayName = 'SlideUpAnimation';

var SlideUp = function SlideUp(_ref) {
  var children = _ref.children,
      visible = _ref.visible,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "visible"]);

  return _react.default.createElement(_reactTransitionGroup.CSSTransition, {
    in: visible,
    timeout: {
      enter: 200,
      exit: 800
    },
    classNames: animationName,
    unmountOnExit: true
  }, _react.default.createElement(SlideUpAnimation, props, children));
};

SlideUp.displayName = 'SlideUp';
SlideUp.propTypes = {
  children: _propTypes.node.isRequired,
  visible: _propTypes.bool.isRequired
};
var _default = SlideUp;
exports.default = _default;